var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.35702 6.21493C1.31097 6.07676 1.31092 5.92716 1.3569 5.78895C2.28247 3.00648 4.90718 1 8.00053 1C11.0924 1 13.7161 3.00462 14.6429 5.78507C14.6889 5.92325 14.689 6.07285 14.643 6.21105C13.7174 8.99352 11.0927 11 7.99936 11C4.90745 11 2.28375 8.99539 1.35702 6.21493Z",
    stroke: "#7F7F7F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 6C9.99999 7.10457 9.10456 8 7.99999 8C6.89542 8 5.99999 7.10457 5.99999 6C5.99999 4.89543 6.89542 4 7.99999 4C9.10456 4 9.99999 4.89543 9.99999 6Z",
    stroke: "#7F7F7F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/showPassword.4fd8d6d20507c28ea58726ad77916d98.svg";
export { ForwardRef as ReactComponent };